define('Components/OutdatedCampaignWidget/js/views/OutdatedCampaignWidgetInstanceView',[
    'jquery',
    'backbone',
    'WidgetInstanceView',
    'app',
    'template!Components/OutdatedCampaignWidget/templates/outdatedCampaign',
    'InternalLinkView',
    'UrlFactory',
],
function($, Backbone, WidgetInstanceView, app, template, InternalLinkView, UrlFactory){
    var OutdatedCampaignWidgetInstanceView = WidgetInstanceView.extend({
        name: 'OutdatedCampaignWidgetInstanceView',
        overlay: 'translucent-light',
        className:'outdated-campaign',
        UrlFactory: 'UrlFactory',
        events: {
            'submit .outdated-campaign__newsletter__form': 'submitNewsletterForm',
            'click .close': 'close',
        },
        remove: function() {
            return this;
        },
        getTemplate:function() {
            return template;
        },
        afterRender:function(){
            app.displayModal(this);
        },
        submitNewsletterForm: function (e) {
            e.preventDefault()
            var view = this,
            form = e.currentTarget,
            input = form.querySelector('input'),
            email = input.value;

            app.getCustomer().registerNewsletter({email: email});

            view.close();
        },
        close: function() {
            this.trigger('close', this);
        }
    })
    OutdatedCampaignWidgetInstanceView.widgetPageViewWithoutJsRender = function(params){
        var view = params.view;
        view.$('[data-widget="OutdatedCampaignWidget"]').each(function(index,el){
            var widgetModel = app.getWidgetInstance(el.dataset.id);
            if(widgetModel){
                $(el).html('');
                var modal = new OutdatedCampaignWidgetInstanceView(widgetModel);
                modal.afterRender();
            }
        });
    };
    return OutdatedCampaignWidgetInstanceView;

});
